module.exports = __webpack_public_path__ + "media/images/icon__burger-menu@2x-aa80e99b3e595461cd71bb408f15dd65.png";